// api
import ModelService from '@/services/model.service'
import { mapState } from 'vuex'

export default {
  name: 'Homepage',

  data() {
    return {
      // 英语 中文 越南语 柬埔寨语 印尼语
      adIdList: '',
      adIdList_pc: [3, 1, 41, 58, 75],
      adIdList_mp: [32, 28, 92, 94, 96],
      // data
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        effect : 'slide',
        loop : true,
        autoplay : {
          delay: 5000,
          disableOnInteraction: false,
        },
      },
      swiperSlides: '',
    };
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex'])
  }),
  watch: {
    LangIndex: {
      handler(str) {
        this.getAdPictureList();
      },
    },
  },
  mounted() {
    this.switchAdlist();
  },
  methods: {
    // 根据客户端切换广告位id
    switchAdlist() {
      if (this.isPC) {
        this.adIdList = this.adIdList_pc;
      } else {
        this.adIdList = this.adIdList_mp;
      }
      this.getAdPictureList();
    },
    // 根据id获取广告图片
    getAdPictureList() {
      const param = {
        lang: this.language,
        adId: this.adIdList[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.swiperSlides = res.data;
        }
      });
    },
  },
};
